<template>
  <div>
    <label
      v-if="data.type"
      style="font-size: 16pt; display: flex; justify-content: center;"
      ><b>
        {{ selectShablonJson.value1 }} OQTOSH
        {{ selectShablonJson.value18 }} bo'lim boshlig'i va davolovchi shifokor
        {{ selectShablonJson.value2 }} ko'ruvi va klinika tashxisni asoslash</b
      ></label
    >
    <br />
    <label
      v-if="!data.type"
      style="font-size: 16pt; display: flex; justify-content: center;"
      ><b> {{ selectShablonJson.value1 }} Operatsiya oldi epikrizi</b></label
    ><br />
    <div>
      <label>1. F.I.O: {{ data.bemor.fullname }}</label>
      <label>2. Jinsi: {{ data.bemor.gender }}</label>
      <label>3. Tug'ilgan kuni: {{ data.bemor.birthday | dateFormat }}</label>
      <label>
        5. Doimiy yashash joyi
        {{ data.bemor.region ? data.bemor.region.name : "" }}
        {{ data.bemor.district ? data.bemor.district.name : "" }}
        {{ data.bemor.addres }}
      </label>
    </div>
    <label class="multiline-text"
      ><b>Kelgandagi shikoyatlari:</b> {{ selectShablonJson.value3 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Anamnezidan:</b> {{ selectShablonJson.value10 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Obyektiv:</b> {{ selectShablonJson.value11 }}</label
    ><br />
    <div v-for="(item, index) in selectShablonJson.value12" :key="index">
      <label
        ><b>{{ item.name }}</b></label
      >
      <br />
      <label>{{ item.value }}</label>
    </div>
    <label><b>Tor mutahasis:</b> {{ selectShablonJson.value20 }}</label
    ><br />
    <label>{{ selectShablonJson.value13 }}</label
    ><br />
    <label
      >Bemor shikoyati, anamnezi abektiv ko'ruv labarator-instrumental tekshiruv
      natijalariga asoslanib quyidagi klinik tashxis qo'yildi.</label
    >
    <br />
    <label><b>Asosiy:</b> {{ selectShablonJson.value6 }}</label
    ><br />
    <label><b>Xamroh:</b> {{ selectShablonJson.value7 }}</label
    ><br />
    <label><b>Asorati:</b> {{ selectShablonJson.value8 }}</label
    ><br />
    <label class="multiline-text"
      ><b>Tavsiyalar:</b> {{ selectShablonJson.value15 }}</label
    ><br /><br /><br />
    <label><b>Davolovchi shifokor:</b> {{ selectShablonJson.value17 }}</label
    ><br />
    <label><b>Bo'lim boshlig'i:</b> {{ selectShablonJson.value19 }}</label
    ><br />
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      selectShablonJson: {},
      data: {}
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created: function() {
    this.data = JSON.parse(localStorage.getItem("klinik_tash"));
    this.selectShablonJson = JSON.parse(this.data.value.toString());
  },
  mounted() {
    localStorage.removeItem("klinik_tash");
    window.print();
    setTimeout(() => {
      //   this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.multiline-text {
  white-space: pre-line;
}
label {
  font-family: "Times New Roman", Times, serif;
  // margin-top: 5px;
  font-size: 14pt;
  line-height: 14pt;
  // font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
}
.display-flex {
  display: flex;
}
</style>
